import React from "react";

import Graphics404 from "../../assets/images/404.svg";

const NotFoundScreen = () => {
  return (
    <>
    <div className="container mx-auto p-4 md:p-8 min-h-[80vh]">
      <div className="flex justify-center items-center w-full h-full min-h-[80vh]">
        <div className="flex items-center flex-wrap sm:flex-nowrap gap-4 max-w-[840px]">
          <div className="w-full sm:w-1/2">
            <h2 className="heading text-[38px] leading-[1.2] font-semibold uppercase mb-2">Oops!</h2>
            <p className="text-[26px] leading-[1.3] font-bold mb-2">The page you are looking for cannot be found.</p>
            <p className="font-bold mb-2">Possible reasons</p>
            <ul className="list-disc ml-3.5">
              <li>The address may have been typed incorrectly.</li>
              <li>It may be a broken or outdated link.</li>
            </ul>
          </div>
          <div className="w-full sm:w-1/2">
            <img src={Graphics404} alt="" className="w-[auto] h-[280px]" />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default NotFoundScreen;
